import * as React from "react";

function SvgTrashIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={25}
      height={30}
      {...props}
    >
      <defs>
        <path
          d="M17.03 24.41h-2.84V10.22h2.84v14.19zm-.87-19.3l-.76-2.27H9.58l-.76 2.27h7.34zm-5.38 19.3H7.95V10.22h2.83v14.19zm9.65-14.19h2.84v19.86H1.7V10.22h2.84v17.02h15.89V10.22zm4.54-5.11v2.84H0V5.11h5.82L7.54 0h9.89l1.73 5.11h5.81z"
          id="trashIcon_svg__a"
        />
      </defs>
      <use xlinkHref="#trashIcon_svg__a" fill="#dedede" />
      <use
        xlinkHref="#trashIcon_svg__a"
        fillOpacity={0}
        stroke="#000"
        strokeOpacity={0}
      />
    </svg>
  );
}

export default SvgTrashIcon;
